export function getGigErrorMessage(error: string): string {
  return `gigs.errors.${error}`;
}
